import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { promotionalBannerQueries } from '@/services/promotionalBanner/promotionalBanner.queries';
import { useSearch } from '@tanstack/react-router';

export const usePromotionalBannerList = () => {
  const search = useSearch({ from: '/(app)/promos-offer/promotional-banner/' });
  const { createdDate, page, fetch, q } = search;
  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isFetched, isLoading } = useQuery({
    ...promotionalBannerQueries.list({
      fromDate: parsedCreatedDate?.start,
      toDate: parsedCreatedDate?.end,
      row: page,
      fetch: fetch,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, search.sort),
    }),
    enabled: !!fetch,
  });

  return {
    promotionalBanner: data?.data || [],
    isFetched,
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
